export const checkSupervisorPermission = (signatureAccess: object, documentType: string) => {
  if (!signatureAccess || !documentType) return false;
  const checkPermission: boolean = Boolean(signatureAccess[documentType as keyof Object]);
  if (checkPermission) {
    return true;
  } else {
    return false;
  }
};
